import React from 'react';
import { motion } from 'framer-motion';
import { ChevronLeftIcon, HeartIcon, InstagramIcon, PhoneIcon, VideoIcon } from 'lucide-react';
const MAMAS_COUNT = '+1.200';
type Message = {
  from: 'mama' | 'cuenta';
  text: string;
};
const conversations: {
  username: string;
  initials: string;
  meta: string;
  time: string;
  messages: Message[];
}[] = [{
  username: 'valen.mrtz',
  initials: 'VM',
  meta: 'Valentina · Buenos Aires',
  time: 'Hace 2 h',
  messages: [{
    from: 'mama',
    text: 'Hola! Semana 2 y el dolor era 9/10, ya estaba por dejar 😢'
  }, {
    from: 'cuenta',
    text: 'Contame, ¿probaste la secuencia de agarre del Tomo 2?'
  }, {
    from: 'mama',
    text: 'Sí!! En 48 hs bajé a 3. No lo puedo creer, gracias de verdad 🙏'
  }]
}, {
  username: 'caro.sosa',
  initials: 'CS',
  meta: 'Carolina · Córdoba',
  time: 'Ayer',
  messages: [{
    from: 'mama',
    text: 'Estaba a punto de suplementar por miedo a que no le alcanzara'
  }, {
    from: 'mama',
    text: 'Usé el tracker y me dio 8 pañales húmedos. Estaba todo bien 🥹'
  }, {
    from: 'cuenta',
    text: 'Eso es tener datos en lugar de miedo. Muy bien mamá 💚'
  }]
}, {
  username: 'lu.rearte',
  initials: 'LR',
  meta: 'Luciana · Rosario',
  time: 'Hace 3 d',
  messages: [{
    from: 'mama',
    text: 'El Tomo 4 me explicó los brotes mejor que todo Google junto'
  }, {
    from: 'mama',
    text: 'Por fin entendí qué le pasaba a Alma a las 6 semanas'
  }, {
    from: 'cuenta',
    text: 'Saber qué esperar cambia todo. Cualquier duda, acá estoy ✨'
  }]
}, {
  username: 'male.fer',
  initials: 'MF',
  meta: 'Malena · Mendoza',
  time: 'Hace 5 d',
  messages: [{
    from: 'mama',
    text: 'Llegué agotada y con muchísima culpa, sentía que hacía todo mal'
  }, {
    from: 'cuenta',
    text: 'No hacés todo mal. Te falta información, que es otra cosa 🤍'
  }, {
    from: 'mama',
    text: 'Tener los pasos claros me devolvió la calma en cada toma'
  }]
}];
export function SocialProof() {
  return <section className="bg-brand-cream px-4 py-16 md:py-20" data-id="element-274" data-mp="1raclo2h7odyr">
      <div className="mx-auto max-w-6xl" data-id="element-275" data-mp="1w8e9t1thv3h3">
        <motion.div initial={{
        opacity: 0,
        y: 18
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mx-auto mb-10 max-w-3xl text-center" data-id="element-276" data-mp="1w7mku9uek3zs">
          <a href="https://www.instagram.com/mamasiincaos/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 rounded-full bg-brand-accent/20 px-4 py-1.5 text-xs font-bold tracking-[0.13em] text-brand-darker uppercase transition-colors hover:bg-brand-accent/30" data-id="element-277" data-mp="2519dvs786t5a">
            <InstagramIcon className="h-4 w-4" aria-hidden="true" data-id="element-278" data-mp="8b6erwmswn0v" /> Mensajes reales · @mamasiincaos
          </a>
          <h2 className="mt-4 font-serif text-4xl leading-tight text-brand-darker md:text-5xl" data-id="element-279" data-mp="3bahshcitvut">
            Lo que nos escriben las mamás por privado.
          </h2>
          <p className="mt-3 text-lg text-brand-darker/70" data-id="element-280" data-mp="3pis28c6y6phr">
            Más de {MAMAS_COUNT} mamás ya transitan su lactancia acompañadas.
          </p>
        </motion.div>

        <div className="grid gap-6 sm:grid-cols-2" data-id="element-281" data-mp="r0d3c0aa08ul">
          {conversations.map((chat, index) => <motion.article key={chat.username} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.08
        }} className="overflow-hidden rounded-3xl border border-brand-primary/30 bg-white shadow-xl" data-id="element-282" data-mp="m44pqrbq8npj" data-mpi={index}>
              <header className="flex items-center gap-3 border-b border-neutral-200 px-4 py-3" data-id="element-283" data-mp="15048dbiteewg">
                <ChevronLeftIcon className="h-5 w-5 shrink-0 text-neutral-400" aria-hidden="true" data-id="element-284" data-mp="pi392dm445fv" />
                <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-brand-accent/25 text-xs font-bold text-brand-darker" data-id="element-285" data-mp="uiqyiuup0e7z">
                  {chat.initials}
                </div>
                <div className="min-w-0 flex-1" data-id="element-286" data-mp="kkbibmx7epd9">
                  <p className="truncate text-sm font-semibold text-neutral-900" data-id="element-287" data-mp="189noedx8ihbc">{chat.username}</p>
                  <p className="truncate text-xs text-neutral-500" data-id="element-288" data-mp="1d87d2m37q77e">{chat.meta}</p>
                </div>
                <div className="flex shrink-0 items-center gap-3 text-neutral-400" aria-hidden="true" data-id="element-289" data-mp="yjub98hg1u4z">
                  <PhoneIcon className="h-4 w-4" data-id="element-290" data-mp="13i5n1orauepu" />
                  <VideoIcon className="h-4 w-4" data-id="element-291" data-mp="13gul7uhezh1d" />
                </div>
              </header>

              <div className="space-y-2.5 bg-white px-4 py-5" data-id="element-292" data-mp="1r6oszxmvmfer">
                <p className="pb-1 text-center text-[11px] text-neutral-400" data-id="element-293" data-mp="1vz87cwte1ekm">{chat.time}</p>
                {chat.messages.map((message, messageIndex) => {
              const isAccount = message.from === 'cuenta';
              return <div key={messageIndex} className={`flex ${isAccount ? 'justify-end' : 'justify-start'}`} data-id="element-294" data-mp="3bo6edere4qag" data-mpi={messageIndex}>
                      <p className={`max-w-[82%] rounded-3xl px-4 py-2.5 text-[15px] leading-relaxed ${isAccount ? 'bg-brand-accent text-brand-darker' : 'bg-neutral-100 text-neutral-800'}`} data-id="element-295" data-mp="3lglyoiq5tqyi">
                        {message.text}
                      </p>
                    </div>;
            })}
                <p className="pt-1 text-right text-[11px] text-neutral-400" data-id="element-296" data-mp="m0754tcse7x7">Visto</p>
              </div>

              <footer className="flex items-center gap-3 border-t border-neutral-200 px-4 py-3" data-id="element-297" data-mp="hybugy8yui6r">
                <span className="flex-1 rounded-full border border-neutral-200 px-4 py-2 text-sm text-neutral-400" data-id="element-298" data-mp="3assinwtn0p1c">
                  Enviar mensaje...
                </span>
                <HeartIcon className="h-5 w-5 text-neutral-300" aria-hidden="true" data-id="element-299" data-mp="3ksb30edgmctx" />
              </footer>
            </motion.article>)}
        </div>

        <p className="mt-8 text-center text-sm text-brand-darker/60" data-id="element-300" data-mp="3ostsi1rvr6sy">
          Mensajes recibidos por DM en{' '}
          <a href="https://www.instagram.com/mamasiincaos/" target="_blank" rel="noopener noreferrer" className="font-semibold text-brand-darker underline decoration-brand-accent underline-offset-4" data-id="element-301" data-mp="2s1j9xproy4at">
            @mamasiincaos
          </a>
          . Nombres de usuario modificados para preservar su privacidad.
        </p>
      </div>
    </section>;
}